var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Login',{attrs:{"login_loading":_vm.login_loading},on:{"get_user_password":_vm.login}},[_vm._v("影院人员入口")])}
var staticRenderFns = []

export { render, staticRenderFns }